/**
 * Returns the user's current UTC offset in hours (e.g., -7 for Pacific, -5 for Eastern).
 * This negates and converts the browser's getTimezoneOffset() which returns
 * minutes in the opposite direction.
 */
export function getLocalTimeOffset(): number {
  return -(new Date().getTimezoneOffset() / 60);
}
